import {useMyLastTripleg} from "./myLastTripleg.ts";
import {VenueStub} from "../rpc/webrpc-client.gen.ts";
import {InfallibleUseResult, pendingUseResult, successUseResult} from "../util/hookutil.tsx";

export function useDockedLocation(): InfallibleUseResult<VenueStub | null> {
    const myLastTriplegTqrv = useMyLastTripleg();
    if (myLastTriplegTqrv.isPending) {
        return pendingUseResult;
    }
    const lastTripleg = myLastTriplegTqrv.data;
    const rv = !!lastTripleg && !!lastTripleg.admitted
            ? lastTripleg.destination
            : null;
    return successUseResult(rv);
}

// function useMyActiveDriverTasks() {
//     const rv: Snaplink[] = [];
//
//     const mountedTruck = useMountedTruck();
//     const lastTripleg = useMyLastTripleg();
//     const openBundleTransfersQo: UseQueryOptions = mountedTruck
//         ? openBundleTransfersForTruckTqo({truckId: mountedTruck.id})
//         : DEADBEEF_QUERY_OPTS;
//     const {data: openBundleTransfers}
//         = useQuery(openBundleTransfersQo);
//     const lastTriplegStatus
//         = lastTripleg ? triplegStatus(lastTripleg) : TriplegStatus.UNKNOWN;
//
//     // the only way our last tripleg status can be unknown is if this truck
//     // has no history. in that case, there's no way to know where it is, so
//     // we have to make the driver start a tripleg and go somewhere.
//     if (lastTriplegStatus === TriplegStatus.UNKNOWN) {
//         return rv;
//     }
//
//     // if we are currently on the road or waiting in line at a prospective
//     // destination, our primary focus only active task should be landing.
//     if (lastTriplegStatus === TriplegStatus.EN_ROUTE ||
//         lastTriplegStatus === TriplegStatus.AWAITING_ADMISSION) {
//
//     }
// }